import { useEffect } from 'react'

import { callDataSelector, useStore } from '@liveHelper/models/store'

import { useIsFocusedTab } from '@core/hooks/useIsFocusedTab'
import { useWebLock } from '@core/hooks/useWebLock'

/**
 * Hook to request video call web lock.
 * @returns A function that releases the lock.
 *
 * TODO: https://fwn.atlassian.net/browse/OTO-3246
 */
export function useVideoCallLock(): (() => void) | undefined {
  const isFocusedTab = useIsFocusedTab()
  const callData = useStore(callDataSelector)
  // Requests a Web Lock when there is an ongoing video call. If granted, the
  // widget should stay pinned to this tab, and not appear on other tabs.
  const releaseVideoCallLock = useWebLock(
    'video-call-lock',
    isFocusedTab && !!callData,
  )

  // Releases the video call Web Lock when a call ends.
  useEffect(() => {
    if (releaseVideoCallLock && !callData) {
      releaseVideoCallLock()
    }
  }, [releaseVideoCallLock, callData])

  return releaseVideoCallLock
}
